import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import DialogProvider from "@components/dialog_provider"
import { useCustomerPageContext } from "@contexts/customer"
import { resendVerificationMail } from "@domain/auth"
import { VerifyUserEmail } from "@domain/customer/infos"
import useControlledForm from "@hooks/use_controlled_form"
import { showErrorToast, showSuccessToast } from "@utils/toast"
import { CustomerPerson } from "__generated__/graphql"

export default function ResendVerificationEmail({
  isOpen,
  setClose,
  selectedRow
}: {
  isOpen: boolean
  setClose: () => void
  selectedRow?: CustomerPerson
}) {
  const { translate } = useCustomerPageContext()
  const [loading, setLoading] = useState(false)

  const {
    handleSubmit,
    reset,
    formState: { isValid }
  } = useControlledForm<VerifyUserEmail>({
    mode: "all"
  })
  function handleClose() {
    if (loading) {
      return
    }
    setClose()
    reset()
  }

  async function onSubmit() {
    if (!selectedRow?._id) {
      return
    }
    setLoading(true)
    const { isSuccess, errorMessage } = await resendVerificationMail(
      selectedRow.email
    )
    setLoading(false)
    if (!isSuccess && !!errorMessage) {
      showErrorToast(errorMessage)
      return
    }
    showSuccessToast("verification_mail_resended")
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={translate("resend_email_verification")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: handleClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("resend"),
        color: "primary",
        onClick: handleSubmit(onSubmit),
        loading: loading,
        disabled: !isValid
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack justifyContent={"center"} alignItems={"center"} flex={1}>
        <Typography align="center">
          {translate("resend_email_verification_description")}
        </Typography>
      </Stack>
    </DialogProvider>
  )
}
